import React from 'react';

import styles from '@/views/pages/Letter/elements/LetterPopover/RoundIcon/RoundIcon.module.scss';

const RoundIcon = ({ bgColor = '#37E5FF', isAuto = false }) => {
	return (
		<div
			className={ styles['round-icon'] }
			style={ {backgroundColor: bgColor} }
		>
			{ isAuto ? (
				<i
					className='icon-auto-change-1' 
					style={ {
						position: 'absolute',
						left: '4px',
						top: '-2px',
						fontSize: '15px',
					} }
				/>
			) : (
				<i 
					className='icon-manual-change' 
					style={ {
						position: 'absolute',
						left: '4px',
						top: '-2px',
						fontSize: '15px',
					} }
				/>
			)}
            
		</div>
	);

};
export default RoundIcon;